import {
    Card,
    Tabs,
    Popover,
    ActionList,
    Icon,
    Button,
    Heading,
    Modal,
    Select,
    TextContainer,
    ChoiceList,
    Stack,
    TextStyle
} from "@shopify/polaris"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../../actions"
import AppManaged from "../../../pages/AppManaged"
import GeneralPage from "../../../pages/GeneralPage"
import ReminderEmail from "../../../pages/ReminderEmailPage"
import BiSPage from "../../../pages/BiSPage"
import StatisticsPage from "../../../pages/StatisticsPage"
import Widgets from "../../../pages/Widgets"
import FaqsComponent from "../../../components/Faqs"
import axios from "../../../funcs/axios"
import TextSettingsPage from "../../../pages/TextSettingsPage"
import {
    CircleTickMajor,
    CircleTickOutlineMinor,
    MobileCancelMajor,
    MobileHorizontalDotsMajor,
} from "@shopify/polaris-icons"
import ThemeIntegration from "../../../pages/ThemeIntegration"
function mapStateToProps(state) {
    return {
        store: state,
        pages: state.pages,
        yout_app: state.yout_app,
        widgets: state.widgets,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}
const FAQ_SHOW_ITEMS_LIMIT = 50
const INITIAL_STATE = {
    isReady: false,
    isLoading: false,
    toast: {
        show: false,
        content: "",
        error: false,
    },
    options: [],
    show: false,
    show_add_section: false,
    checkInstall: false,
    tabSelected: 0,
    active: false,
    optionThemes: [],
    parentTabs: 0,
    selectReinstall: "0",
    faqData: []
}

class AppBodyWishlist extends Component {
    constructor(props) {
        super(props)
        // this.state = Object.assign({}, INITIAL_STATE)
        this.state = {
            isReady: false,
            isLoading: false,
            toast: {
                show: false,
                content: "",
                error: false,
            },
            options: [],
            show: false,
            show_add_section: false,
            checkInstall: false,
            tabSelected: 0,
            active: false,
            optionThemes: [],
            parentTabs: 0,
            selectReinstall: "0",
            checkClose: this.props.checkClose,
            faqData: []
        }

        this.loadTemplatePage()
    }

    componentDidMount() {
        // this.initAppData();
        this.loadFaqs();
    }

    handleTabChange = (index: number): void => {
        const { actions } = this.props
        actions.switchPagesAction(index)
    }

    loadTemplatePage() {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/load-template-page`).then((res) => {
            let pages = res.data.pages.pages
            let array = []
            pages.map((item) => {
                let obj = {
                    label: item.title,
                    value: item.handle,
                }
                array.push(obj)
            })
            this.setState({ options: array })
        })
    }

    handleChangeTabs = async (item, index) => {
        this.setState({
            tabSelected: index,
        })
    }

    handleClickTabs = async (pages, index) => {
        const { actions } = this.props
        actions.switchPagesAction(pages)
        if (index != null) {
            let item = {
                id: index,
            }
            await actions.changeWidgetSelectedAction(item)
            actions.switchPagesConfigAction("WidgetsSetting")
            let content = document.querySelector(".widget-create")
            content.scrollIntoView()
        } else {
            await actions.switchPagesConfigAction("WidgetsManagement")
            let content = document.querySelector(".widgets-management-body")
            content.scrollIntoView()
        }
    }

    handleShow() {
        this.setState({ show: true })
    }

    handleChangeParentTabs = (index) => {
        this.setState({ parentTabs: index })
    }

    handleClose() {
        this.setState({ show: false })
    }

    handleCloseTabs = () => {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/close-tabs`).then((response) => {
            const resObj = response.data
            if (resObj.status === "error") {
                throw new Error(resObj.msg)
            } else {
                this.setState({
                    checkClose: response.data.checkClose,
                })
            }
        })
    }

    toggleActive = () => {
        this.setState({ active: !this.state.active })
    }

    handleReInstall() {
        const { selectReinstall, selected } = this.state
        const { actions } = this.props
        let data = {
            id: selected,
            option: selectReinstall[0],
        }
        this.setState({
            appWaiting: true,
            show: false,
        })
        axios
            .post(`${window.SHOPIFY_APP_HOST}/admin/install-wishlist-assets`, data)
            .then((response) => {
                const resObj = response.data
                if (resObj.status === "success") {
                    this.props.actions.AppNotify({
                        content: "Re-install successfully",
                        show: true,
                        error: false,
                    })
                    setTimeout(() => {
                        window.location.reload()
                    }, 0)
                } else {
                    throw new Error(resObj.msg)
                }
            })
            .catch((err) => {
                actions.AppNotify({
                    content: `Re-install fail. Please try again.`,
                    show: true,
                    error: true,
                })
            })
            .finally(() => {
                this.setState({
                    appWaiting: false,
                })
            })
    }

    loadFaqs() {
        let url = `${window.SHOPIFY_APP_HOST}/admin/get-faqs`;
        let data = {
            pages: null
        };
        axios.post(url, data).then((response) => {
            let data = response.data
            if (data.success) {
                this.setState({ faqData: data.payload && data.payload.data ? data.payload.data : [] })
            }
        })
    }

    mapPageNameToMapHandle(mapName) {
        return mapName ? mapName.toLowerCase().replace(/ /g,'-') : null;
    }

    renderComponent = () => {
        const { pages, optionThemes, selected, themesInstall, metafieldId } = this.props
        const { options } = this.state

        switch (pages.selected) {
            case 0:
                return <GeneralPage options={options} />

            case 1:
                return <Widgets />

            case 2:
                return <Widgets />
            case 3:
                return <BiSPage />
            case 4:
                return <ReminderEmail />

            case 5:
                return <StatisticsPage />
            case 6:
                return <TextSettingsPage metafieldId={metafieldId}/>
            case 7:
                return (
                    <ThemeIntegration
                        optionThemes={optionThemes}
                        selected={selected}
                        themesInstall={themesInstall}
                    />
                )
            default:
                return <StatisticsPage />
        }
    }

    renderComponent_FAQ = () => {
        const { pages, selected } = this.props
        const { data: dataPages, selected : selectedPage } = pages
        const { faqData } = this.state
        const faqDataOfPage = faqData.filter(item => item.attributes.page === this.mapPageNameToMapHandle(dataPages[selectedPage].id))
        if (faqDataOfPage.length === 0) {
            return null;
        }
        faqDataOfPage.sort((a,b) => { 
            if (a.attributes.order < b.attributes.order) {
                return -1;
            }
            if (a.attributes.order > b.attributes.order) {
                return 1;
            }
            return 0;
         })
        return (
            <Card.Section>
                <div className="standard">
                    <div className="standard-left">
                        <Stack vertical className="standard-left">
                            <TextStyle variation="strong">FAQs</TextStyle>
                            <TextStyle variation="subdued">
                            </TextStyle>
                        </Stack>
                    </div>
                    <div className="standard-right">
                        <FaqsComponent items={faqDataOfPage || []} limit={FAQ_SHOW_ITEMS_LIMIT} />
                    </div>
                </div>
            </Card.Section>
        )
    }

    render() {
        const { pages } = this.props
        const { tabSelected, active, parentTabs, show, selectReinstall, checkClose } = this.state
        const { checkInstall, optionThemes, selected, handleShow } = this.props
        let themeName = ""
        let themeSelected = optionThemes.find((item) => item.value == selected)
        if (themeSelected) {
            themeName = themeSelected.label
        }
        const tabs = [
            [
                {
                    id: 0,
                    name: `Add theme code: ${checkInstall ? "Active" : "Pending"}`,
                    heading: "Before starting, a theme code will be inserted into your theme:",
                    content: checkInstall
                        ? `Your theme code is already inserted in your theme package: ${themeName}`
                        : `* Please click Insert add code button for the app to work`,
                    button: checkInstall
                        ? `Insert the app code into another theme package`
                        : "Insert add code to your theme",
                    action: () => handleShow(),
                },
                {
                    id: 1,
                    name: "Insert Wishlist Button",
                    heading: "Make changes to your wishlist",
                    content: ``,
                    button: "Insert the app code into another theme package",
                    action: () => this.handleClickTabs(1),
                },
                {
                    id: 2,
                    name: "Configure Show Wishlist Button",
                    heading: "Make changes to your wishlist",
                    content: ``,
                    button: "Configure Show Wishlist Button",
                    action: () => this.handleClickTabs(1, 0),
                },
                {
                    id: 3,
                    name: "Configure Add to Wishlist Button",
                    heading: "Make changes to your wishlist",
                    content: ``,
                    button: "Configure Add to Wishlist Button",
                    action: () => this.handleClickTabs(1, 1),
                },
                {
                    id: 4,
                    name: "Configure Remove Wishlist Button",
                    heading: "Make changes to your wishlist",
                    content: ``,
                    button: "Configure Remove Wishlist Button",
                    action: () => this.handleClickTabs(1, 2),
                },
            ],
            [
                {
                    id: 0,
                    name: `Add theme code: ${checkInstall ? "Active" : "Pending"}`,
                    heading: "Before starting, a theme code will be inserted into your theme:",
                    content: `Your theme code is already inserted in your theme package: `,
                    button: "Insert app code to another theme package",
                    action: () => handleShow(),
                },
                {
                    id: 1,
                    name: "Insert Compare Button",
                    heading: "Make changes to your Compare",
                    content: ``,
                    button: "Insert app code to another theme package",
                    action: () => this.handleClickTabs(2),
                },
                {
                    id: 2,
                    name: "Configure Show Compare Button",
                    heading: "Make changes to your Compare",
                    content: ``,
                    button: "Configure Show Compare Button",
                    action: () => this.handleClickTabs(2, 0),
                },
                {
                    id: 3,
                    name: "Configure Add to Compare Button",
                    heading: "Make changes to your Compare",
                    content: ``,
                    button: "Configure Add to Compare Button",
                    action: () => this.handleClickTabs(2, 1),
                },
                {
                    id: 4,
                    name: "Configure Remove Compare Button",
                    heading: "Make changes to your Compare",
                    content: ``,
                    button: "Configure Remove Compare Button",
                    action: () => this.handleClickTabs(2, 2),
                },
            ],
        ]

        const activator = (
            <Button
                icon={MobileHorizontalDotsMajor}
                plain
                onClick={() => this.toggleActive()}
            ></Button>
        )

        let wishlistTabs = {
            content: "Wishlist",
            onAction: () => this.handleChangeParentTabs(0),
        }

        let compareTabs = {
            content: "Compare",
            onAction: () => this.handleChangeParentTabs(1),
        }

        let closeTabs = {
            content: "Close",
            onAction: () => this.handleCloseTabs(),
        }

        const moreTabs = []

        parentTabs == 0 ? moreTabs.push(compareTabs) : moreTabs.push(wishlistTabs)
        if (checkInstall) {
            moreTabs.push(closeTabs)
        }
        return (
            <div className="yta-body">
                <Modal
                    open={show}
                    onClose={() => this.handleClose()}
                    title="Install Theme"
                    primaryAction={{
                        content: "Save Changes",
                        onAction: () => this.handleReInstall(),
                    }}
                    secondaryActions={[
                        {
                            content: "Close",
                            onAction: () => this.handleClose(),
                        },
                    ]}
                >
                    <Modal.Section>
                        <TextContainer>
                            <div>
                                <ChoiceList
                                    choices={[
                                        {
                                            label: "Return default settings",
                                            value: "0",
                                        },
                                        {
                                            label: "Keep old settings adding new options only",
                                            value: "1",
                                        },
                                    ]}
                                    selected={selectReinstall}
                                    onChange={(val) => {
                                        this.setState({
                                            selectReinstall: val,
                                        })
                                    }}
                                />

                                <Select
                                    label="Active Theme"
                                    options={optionThemes}
                                    onChange={(value) => {
                                        this.setState({
                                            selected: +value,
                                        })
                                    }}
                                    value={selected}
                                />
                            </div>
                        </TextContainer>
                    </Modal.Section>
                </Modal>
                {!checkClose ? (
                    <div style={{ marginBottom: "20px" }}>
                        <Card sectioned>
                            <div className="tabs-actions">
                                <Heading>Moving along nicely with Wishlist - Compare</Heading>
                                <Popover
                                    active={active}
                                    activator={activator}
                                    onClose={() => this.toggleActive()}
                                >
                                    <ActionList items={moreTabs} />
                                </Popover>
                            </div>
                            <div className="tabs-wishlist">
                                <div className="tabs-left">
                                    {tabs[parentTabs].map((item, index) => {
                                        return (
                                            <div
                                                key={index}
                                                onClick={() => this.handleChangeTabs(item, index)}
                                                className={`flex-icon ${
                                                    tabSelected == index ? "selected" : ""
                                                }`}
                                            >
                                                <Icon
                                                    source={CircleTickMajor}
                                                    color={
                                                        tabSelected == index ? "primary" : "subdued"
                                                    }
                                                    backdrop
                                                ></Icon>
                                                <span className="flex-text">{item.name}</span>
                                            </div>
                                        )
                                    })}
                                </div>
                                <div className="tabs-right">
                                    <Heading>{tabs[parentTabs][tabSelected].heading}</Heading>
                                    <p>{tabs[parentTabs][tabSelected].content}</p>
                                    <Button
                                        primary
                                        className="btn-add-theme"
                                        onClick={() => tabs[parentTabs][tabSelected].action()}
                                    >
                                        {tabs[parentTabs][tabSelected].button}
                                    </Button>
                                    {tabs[parentTabs][tabSelected].id == 0 && (
                                        <a
                                            href={`https://support.arenacommerce.com/support/solutions/articles/6000246930-app-code-s-position-in-your-theme`}
                                            target="_blank"
                                        >
                                            App code's position in your theme
                                        </a>
                                    )}
                                </div>
                            </div>
                        </Card>
                    </div>
                ) : (
                    ""
                )}
                <div className="yta-header2">
                    <div className="header-tabs-block">
                        <Card>
                            <Tabs
                                tabs={pages.data}
                                selected={pages.selected}
                                onSelect={(index) => this.handleTabChange(index)}
                            />
                        </Card>
                    </div>
                </div>

                <div className="main-body">
                    <Card>
                        <Card.Section>{this.renderComponent()}</Card.Section>
                        {/* <!-- FAQS --> */}
                        {this.renderComponent_FAQ()}
                    </Card>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppBodyWishlist)
